/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { ITivoSubscription, TivoSubscriptionModel } from '../tivo';
import { UIOrchestratorState } from './UIOrchestratorState';

export class UIOrchestrator {
    public static stateChangeListener: ITivoSubscription<UIOrchestratorState> =
        new TivoSubscriptionModel();
}
